import { Tile as TileLayer } from 'ol/layer'
import { XYZ } from 'ol/source'
import { ILayer } from 'shared/api/user'

export const createXyzLyr = (layer: ILayer, isBase: boolean) => {
	let wmsName = layer.WMSName

	if (wmsName.startsWith('./')) {
		wmsName = wmsName.substring(2)
		wmsName = '/gisbis/' + wmsName
	} else {
		wmsName = 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
	}

	console.log({ layer, wmsName })

	return new TileLayer({
		source: new XYZ({
			url: wmsName,
			crossOrigin: 'Anonymous',
		}),
		properties: {
			title: layer.name,
			idLayer: layer.id,
			type: isBase ? 'base' : 'overlay',
			autoload: layer.autoload,
			group: layer.LayerGroup,
			classifierFilterRules: layer.classifierFilterRules,
			hideOnSatelliteView: layer.hideOnSatelliteView,
		},
	})
}
